import { Img } from '@/components/blocks/MaterialImage';
import { ModalOutfits } from '@/components/blocks/ModalOutfits';
import { combineSX } from '@/utils/combineSX';
import { ButtonBase, Grid, SxProps } from '@mui/material';
import { useIsOpen } from 'integration/hooks/useIsOpen';

export const DpOutfitFrame: React.FC<React.PropsWithChildren> = ({ children, ...props }) => {
	return (
		<Grid container spacing={2} {...props}>
			{children}
		</Grid>
	);
};

interface DpOutfitCardProps {
	src: string;
	modal_src: string;
	alt: string;
	part_numbers: string[];
	sx?: SxProps;
	imagesx?: SxProps;
}

export const DpOutfitCard = ({
	src,
	modal_src,
	alt,
	part_numbers,
	sx,
	imagesx,
	...props
}: DpOutfitCardProps) => {
	const openModal = useIsOpen();

	return (
		<>
			<Grid
				item
				sx={combineSX([
					{ position: 'relative', cursor: 'pointer' },
					...(Array.isArray(sx) ? sx : [sx]),
				])}
				xs={12}
				md={4}
				onClick={openModal.on}
				{...props}
			>
				<Img
					src={src}
					alt={alt}
					sx={combineSX([
						{
							width: '100%',
							height: 'auto',
						},
						...(Array.isArray(imagesx) ? imagesx : [imagesx]),
					])}
				/>
				<ButtonBase
					sx={{
						position: 'absolute',
						bottom: '16px',
						left: '50%',
						transform: 'translateX(-50%)',
						justifyContent: 'center',
						alignItems: 'center',
						textTransform: 'none',
						backgroundColor: '#333333',
						borderRadius: '50px',
						width: '113px',
						height: '44px',
						fontSize: '15px',
						fontWeight: 600,
						color: '#FFFFFF',
					}}
				>
					{'Ver Look'}
				</ButtonBase>
			</Grid>
			{openModal.open ? (
				<ModalOutfits
					image={modal_src || src}
					part_numbers={part_numbers}
					onClose={openModal.off}
				/>
			) : null}
		</>
	);
};
